import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams, useLocation } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import { Helmet } from "react-helmet";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import { Loader, Get, priceFormat, DateToText } from "../inc/Fetch";
import { Config } from '../../inc/Config';
import { Img } from "../components/Elements";
import { ImageUpload, Input, Select } from "../components/Form";
import Product from "../components/product/Product";
import ErrorPage from "./ErrorPage";

import { GoSquareFill } from "react-icons/go";
import { MdArrowForwardIos } from "react-icons/md";


import Header from "./Header";
import Footer from "./Footer";

// ads

import './css/history.css'

export default function History() {

    const { t } = useTranslation();
    let ref = useRef();
    const params = useParams();
    const location = useLocation();

	const {siteData, user} = useContext(AppContext); 
	const [userinfo, setuserinfo] = user;

    const [loader, setloader] = useState(false);
    const [loading, setloading] = useState(true);
    const [data, setdata] = useState([]);

    async function loadData() {

        setloading(true);
        let res = await Get("history");
        setloading(false);

        setdata(res);

    }

    useEffect(() => {
        loadData();
    }, [])
    
    
    if (!userinfo?._id && !loading) {
        return <ErrorPage />
    }

    if (loading) {
        return <Loader />
    }

	return (
		<>
            {loader && <Loader />}
            {/* {isFetching && <Loader />} */}
            <Helmet>
                <title>{t("user_orders_history")}</title>
                <meta property="og:title" content={t("user_orders_history")} />
            </Helmet>

			<Header title={true} /> 

            <nav className='mainWidth pathNames'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link >{t("user_orders_history")}</Link>
                
            </nav>

        

            <div className='mainWidth historyBox'>

                <table className='table'>
                    <thead>
                        <tr>
                            <td style={{maxWidth:20}}>{t("thanks_order_id")}</td>
                            <td style={{maxWidth:150, minWidth:150}} className='text-right'>{t("history_name")}</td>
                            <td style={{maxWidth:30}}>{t("history_products_number")}</td>
                            <td style={{maxWidth:40}}>{t("history_date")}</td>
                            <td style={{maxWidth:150, minWidth:150}}>{t("status")}</td>
                            <td style={{maxWidth:40}}>{t("cart_total")}</td>
                        </tr>
                    </thead>

                    <tbody>
                        {data?.map((v, k) => {
                            
                            return (
                                <tr>
                                    <td ><Link to={`/historyInfo/${v?._id}`} state={{ previousLocation: location }}>{v?.orderID}</Link></td>
                                    <td className='text-right'>{v?.customer?.name}</td>
                                    <td>{v?.cart?.length}</td>
                                    <td ><DateToText time={v?.date} /></td>
                                    <td><span style={{padding:"6px 10px", }} className={`tag blue col-${v?.status}`}>{t(`history_status_${v?.status}`)}</span></td>
                                    <td><b>{priceFormat(v?.total)} {v?.currency?.val}</b></td>
                                </tr>
                            );
                        })}
                    </tbody>

                </table>

                {!data?.length ? <div className='noData2'>{t("no_data")}</div>: false}
                
            </div>
            
            <Footer />
		</>
	)
}
